import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const StyledTypography = styled(Typography)`
  margin-bottom:  1rem;

  ${tablet768`
    max-width: 32.25rem;
    margin-bottom: 2rem;
  `};

  ${desktop1024`
    max-width: 26rem;
  `};
`;

StyledTypography.displayName = 'StyledTypography';

export const StyledTitleTypography = styled(Typography)`
  width: 14rem;

  ${tablet768`
    width: 20rem;
  `}

  ${desktop1024`
    width: 100%;
  `}
`;

StyledTitleTypography.displayName = 'StyledTitleTypography';

export const StyledSubtitleTypography = styled(Typography)`
  ${desktop1024`
    width: 38rem;
  `}
`;
